import TitleBlock from '@anm/components/TitleBlock';
import styled from 'styled-components';

import { CheckBoxWrapper } from '../PlayButtonCheckbox/Wrapper';
import { subTitleStyles } from '../Wrapper';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  text-align: left;

  ${CheckBoxWrapper} {
    padding: 8px 10px;
    margin-left: 36px;
  }
`;

export const SizesWrapper = styled.div``;

export const Subtitle = styled(TitleBlock)`
  ${subTitleStyles};
  margin-bottom: 7px;
`;
